<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-primary bg-soft">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome to Echo!</h5>
                  <p>Let's set up your organization</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          
          <div class="card-body pt-0">
            <div class="p-2">
              <div class="text-center mt-4">
                <div class="avatar-lg mx-auto mb-4">
                  <div class="avatar-title rounded-circle bg-light">
                    <i class="bx bxs-building h1 mb-0 text-primary"></i>
                  </div>
                </div>
                
                <h4 class="mb-3">Organization Setup</h4>
                <p class="text-muted mb-4">
                  You're the first person from your organization to sign in. 
                  Let's create your organization profile.
                </p>

                <div class="alert alert-info text-start" role="alert">
                  <strong>Organization Details:</strong>
                  <div class="mt-2">
                    <div class="mb-2">
                      <small class="text-muted">Organization ID:</small><br>
                      <strong>{{ organizationId || 'Loading...' }}</strong>
                    </div>
                    <div>
                      <small class="text-muted">Organization Name:</small><br>
                      <strong>{{ organizationName || 'Loading...' }}</strong>
                    </div>
                  </div>
                </div>

                <div class="mt-4">
                  <button 
                    type="button" 
                    class="btn btn-primary btn-lg w-100"
                    (click)="setupOrganization()"
                    [disabled]="isLoading || !organizationId">
                    <span *ngIf="!isLoading">
                      <i class="bx bx-check-circle me-1"></i>
                      Setup Organization
                    </span>
                    <span *ngIf="isLoading">
                      <i class="bx bx-loader bx-spin me-1"></i>
                      Setting up...
                    </span>
                  </button>
                </div>

                <div class="mt-4">
                  <p class="text-muted mb-0">
                    <i class="bx bx-info-circle me-1"></i>
                    This will create your organization profile and allow team members to join.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
